import type { LinkInternal } from '@backmarket/http-api'

import { createHttpEndpoint } from '../utils'

export interface ProductListPage {
  id: string
  landing_type: string
  links: Record<string, LinkInternal>
  urls: Record<string, string>
  electronic_waste: Record<string, string>
  text_seo: string
  title_seo: string
  description_seo: string
  displayed_title: string
  displayedTitlePlural: string
  tagline: string
  display_hero_and_rates: boolean
  hero: never
  buying_guide: {
    id: number
    slug: string
    banner: string
    banner_alt: string
    title: string
    category: string
    summary: string
    link: LinkInternal
  }
  list_view_structure: {
    title: Array<{
      attribute: string
      suffix?: string
      prefix?: string
    }>
    table: Array<{
      label: string
      attributes: Array<{
        attribute: string
        suffix?: string
      }>
    }>
  }
  isVanishingDeals: boolean
  marketing_content: {
    card: {
      link: {
        url: string
        text: string
      }
      alt: string
      urls: {
        small: string
        large: string
      }
    }
    list: {
      link: {
        url: string
        text: string
      }
      alt: string
      urls: {
        small: string
        large: string
      }
    }
  }
}

export interface Crumb {
  title: string
  link: LinkInternal
}

/**
 * Returns the product list page breadcrumbs
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/landing-page-api/definition#tag/landing-page/operation/get-landing_page-breadcrum}
 */
export const getBreadcrumb = createHttpEndpoint<Crumb[]>({
  method: 'GET',
  operationId: 'getLandingPageBreadcrumb',
  path: '/bm/landing_page/breadcrumb',
})

/**
 * Given a product list page, returns general information like text to display
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/landing-page-api/definition#tag/landing-page/operation/landingPageMainView}
 */
export const getProductListPage = createHttpEndpoint<ProductListPage>({
  method: 'GET',
  operationId: 'landingPageMainView',
  path: '/bm/landing_page',
  transformResponseToCamelCase: true,
})
